<div class="mybets-scoreboard">
    <ng-content select="[players]"></ng-content>
    @if (vm().started) {
        <ng-content select="[stats]"></ng-content>
    }
</div>
